import { ClientWorkOrderFolder } from "@redotech/redo-model/views/folders";
import { ClientWorkOrderView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getWorkOrderViewsAndFolders = {
  name: "getWorkOrderViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientWorkOrderFolder),
    views: z.array(ClientWorkOrderView),
  }),
};
